/* eslint-disable eqeqeq */
import {
  CmpSelectBox,
  CmpTextField,
  CmpButton,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button, CircularProgress } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import { fcovertToNumber, fErrorMessage } from "../../Utility/Utilitys";
import Loading_Breadcrumbs from "./Loading_BreadCrumbs";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { confirmAlert } from "react-confirm-alert"; // Import
// import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { LoadingHead_Status_Set } from "./SliceLoading";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./Loading.css";
import { LoadingDetailCard } from "./LoadingDetailCard";
import { LoadingVarianceCard } from "./LoadingVarianceCard";
import { WMS_PICKING_DROP_ID_Flag } from "./LoadingAction";
import { LoadingDetailTblCard } from "./component/LoadingDetailTblCard";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { LoadingVarianceTblCard } from "./component/LoadingVarianceTblCard";

const columns = [
  {
    field: "G_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "G_BinCd",
    headerName: "LoadingBay Code",
    width: 80,
    hide: true,
  },
  {
    field: "BinName",
    headerName: "LoadingBay",
    width: 150,
  },
  {
    field: "G_CardID",
    headerName: "Barcode Code",
    width: 130,
  },
  {
    field: "G_ItmCd",
    headerName: "Item Code",
    width: 100,
    hide: true,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 250,
  },
  {
    field: "G_Qty",
    headerName: "Qty",
    width: 80,
  },
  {
    field: "G_Unit",
    headerName: "Unit Code",
    width: 50,
  },
  {
    field: "G_BaseQty",
    headerName: "BaseQty",
    width: 70,
  },
  {
    field: "G_NDX_ROWID",
    headerName: "G_NDX_ROWID",
    width: 50,
    hide: true,
  },
  {
    field: "G_RefDocTyp",
    headerName: "RefDocTyp",
    width: 100,
    hide: true,
  },
  {
    field: "G_RefDocNo",
    headerName: "RefDocNo",
    width: 100,
    hide: true,
  },
];

const VarianceColumns = [
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 90,
  },
  {
    field: "Name1",
    headerName: "Item Name",
    width: 400,
  },
  // {
  //     field: 'picked',
  //     headerName: 'Picked',
  //     width: 80,
  // },
  {
    field: "Qty",
    headerName: "Qty",
    width: 100,
  },
  {
    field: "PkdQty",
    headerName: "PkdQty",
    width: 100,
  },
];

export default function LoadingDetail() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LoadingDetailFocusOnLoad = useRef(null);
  const vRdxDetail = useSelector(
    (state) => state.SliceLoading.value.LoadingHead
  );
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sLoading, setLoading] = useState(false);
  const [sGridRow, setGridRow] = useState([]);
  const [sGridVarienceRow, setGridVarienceRow] = useState([]);
  const [sUnitData, setUnitDataArr] = useState([]);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const [sDetail, setDetail] = useState({
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    SuppRefNo1: 0,
    BarCode: "",
    CardId: "",
    Qty: 0,
    DropID: "",
    Unit: "",
    PackQty: 0,
    BaseQty: 0,
    LoadQty: 0,
    LoadingQty: 0,
    BalanceQty: 0,
    IndexRowID: 0,
    RefDocTyp: "",
    RefDocNo: "All",
  });
  let vDetailObjInit = {
    SrNo: 0,
    ItemCode: "",
    ItemName: "",
    SuppRefNo1: 0,
    BarCode: "",
    CardId: "",
    Qty: 0,
    DropID: "",
    Unit: "",
    PackQty: 0,
    BaseQty: 0,
    LoadQty: 0,
    LoadingQty: 0,
    BalanceQty: 0,
    IndexRowID: 0,
    RefDocTyp: "",
    RefDocNo: "All",
  };
  const [sErrorMsg, setErrorMsg] = useState({
    SrNo: "",
    ItemCode: "",
    ItemName: "",
    BarCode: "",
    CardId: "",
    Qty: "",
    DropID: "",
    Unit: "",
    PackQty: "",
    BaseQty: "",
    LoadQty: "",
    LoadingQty: "",
    BalanceQty: "",
  });

  let vErrorInit = {
    SrNo: "",
    ItemCode: "",
    ItemName: "",
    BarCode: "",
    CardId: "",
    Qty: "",
    DropID: "",
    Unit: "",
    PackQty: "",
    BaseQty: "",
    LoadQty: "",
    LoadingQty: "",
    BalanceQty: "",
  };

  const [sOpenDetailViewModel, setOpenDetailViewModel] = useState(false);

  const fCloseDetailViewModel = () => {
    setOpenDetailViewModel(false);
  };

  const fOpenDetailViewModel = () => {
    setOpenDetailViewModel(true);
  };
  const [sOpenPostVarianceModel, setOpenVarianceModel] = useState(false);

  const fCloseVarianceModel = () => {
    setOpenVarianceModel(false);
  };

  const fOpenVarianceModel = () => {
    setOpenVarianceModel(true);
  };

  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      GetCartBarcodeDetail(sDetail.SrNo, sDetail.BarCode, false);
    } else if (e.key === "Backspace" || e.keyCode === 8) {
      setDetail((obj) => ({
        ...obj,
        ItemCode: "",
        ItemName: "",
        Unit: "",
        PackQty: 0,
        LoadQty: 0,
        LoadingQty: 0,
        BalanceQty: 0,
        SuppRefNo1: 0,
      }));
      fBaseQty(sDetail.Qty, 0);
      setUnitDataArr([]);
    } else if (
      e.key === "Delete" ||
      e.keyCode === 46 ||
      e.key === "Backspace"
    ) {
      if (sDetail.BarCode == "" || sDetail.CardId) {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          ItemName: "",
          Unit: "",
          PackQty: 0,
          LoadQty: 0,
          LoadingQty: 0,
          BalanceQty: 0,
          SuppRefNo1: 0,
        }));
        fBaseQty(sDetail.Qty, 0);
        setUnitDataArr([]);
      }
    }
  };

  const fOnChangeInput = (e) => {
    setDetail((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < sDetail.BarCode.toString().length &&
      vMediaQuery &&
      e.target.name === "BarCode"
    ) {
      var eObj = {
        key: "Backspace",
      };
      if (e.target.value !== "" && vMediaQuery) {
        fOnKeyUp(eObj);
      }
    }
  };

  const fOnChangeInputQty = (e) => {
    setDetail((obj) => ({
      ...obj,
      [e.target.name]: Number(e.target.value),
    }));
    fBaseQty(e.target.value, sDetail.PackQty);
  };
  const fQtyKey = (e) => {
    if (e.key === "Enter" || e.keyCode === 13) {
      setLoading(true)
      if (sDetail.Qty !== "") {
        e.target.blur();
        fSave();
      }else{
        setLoading(false)
      }
    }
  };

  const fUnitSelect = useCallback(
    (e) => {
      let vUnit = sUnitData.find((obj) => {
        return obj.Unit == e.target.value;
      });
      fBaseQty(sDetail.Qty, vUnit.PackQty);
      setDetail((obj) => ({
        ...obj,
        Unit: vUnit.Unit,
        PackQty: vUnit.PackQty,
      }));
    },
    [sDetail, sUnitData]
  );

  const setValidation = () => {
    setErrorMsg(vErrorInit);
    let iRes = true;
    if (sDetail.SrNo === "") {
      setErrorMsg((obj) => ({ ...obj, SrNo: "SrNo is Empty" }));
      iRes = false;
    }
    if (sDetail.BarCode === "") {
      setErrorMsg((obj) => ({ ...obj, BarCode: "BarCode is Empty" }));
      iRes = false;
    }
    if (sDetail.DropID === "" && WMS_PICKING_DROP_ID_Flag()) {
      setErrorMsg((obj) => ({ ...obj, DropID: "DropID is Empty" }));
      iRes = false;
    }
    if (sDetail.Qty === "") {
      setErrorMsg((obj) => ({ ...obj, Qty: "Qty is Empty" }));
      iRes = false;
    } else if (Number(sDetail.Qty) <= 0) {
      setErrorMsg((obj) => ({ ...obj, Qty: "Qty is Zero" }));
      iRes = false;
    }
    if (sDetail.ItemCode === "") {
      setErrorMsg((obj) => ({ ...obj, ItemCode: "ItemCode is Empty" }));
      iRes = false;
    }
    if (sDetail.ItemName === "") {
      setErrorMsg((obj) => ({ ...obj, ItemName: "ItemName is Empty" }));
      iRes = false;
    }
    if (sDetail.Unit === "") {
      setErrorMsg((obj) => ({ ...obj, Unit: "Unit is Empty" }));
      iRes = false;
    }
    if (sDetail.BaseQty === "") {
      setErrorMsg((obj) => ({ ...obj, BaseQty: "BaseQty is Empty" }));
      iRes = false;
    }
    if (sDetail.LoadQty === "") {
      setErrorMsg((obj) => ({ ...obj, LoadQty: "LoadQty is Empty" }));
      iRes = false;
    }
    if (sDetail.LoadingQty === "") {
      setErrorMsg((obj) => ({ ...obj, LoadingQty: "LoadingQty is Empty" }));
      iRes = false;
    }
    if (sDetail.BalanceQty === "") {
      setErrorMsg((obj) => ({ ...obj, BalanceQty: "BalanceQty is Empty" }));
      iRes = false;
    }
    return iRes;
  };
  let timeout = null;
  const fSave = async (e) => {
    setLoading(true)
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      setLoading(false)
      if (setValidation()) {
        let vResp = await GetSaveItems();
        if (vResp.Type == "SUCCESS") {
          fAlertToast("SUCCESS", "Successfully Saved");
          fNew();
        }
      }
    }, 800);
  };

  const fDelete = (e) => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to Delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            fClearErrorMsg();
            let vResp = await GetDeleteItems();
            if (vResp.Type == "SUCCESS") {
              fAlertToast("SUCCESS", "Successfully Deleted");
              fNew();
              document.getElementsByName("BarCode")[0]?.focus();
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => document.getElementsByName("BarCode")[0]?.focus(),
        },
      ],
    });
  };

  const fClearErrorMsg = (e) => {
    setErrorMsg(vErrorInit);
  };

  const fNew = async (e) => {
    let vDropID = sDetail.DropID;
    fClearErrorMsg();
    setUnitDataArr([]);
    setDetail(vDetailObjInit);
    GetItems();
    setDetail((obj) => ({
      ...obj,
      DropID: vDropID,
    }));
    document.getElementsByName("BarCode")[0]?.focus();
  };

  const fPost = (e) => {
    fClearErrorMsg();
    GetPost();
    document.getElementsByName("BarCode")[0]?.focus();
  };

  const fVariance = (e) => {
    GetVariance();
    fOpenVarianceModel();
  };
  const fDetail = (e) => {
    fOpenDetailViewModel();
  };
  const fBaseQty = (xQty, xPackQty) => {
    let vBaseQty = fcovertToNumber(xPackQty) * fcovertToNumber(xQty);
    setDetail((obj) => ({
      ...obj,
      BaseQty: vBaseQty,
    }));
  };

  //API LOADING_ITEMSEARCH_GETROW
  const GetCartBarcodeDetail = async (xSrno, xBarcode, xeditRow) => {
    const CartBarcodeDetailObj = {
      VocTyp: vRdxDetail.VocTyp,
      VocNo: vRdxDetail.VocNo,
      SrNo: xSrno,
      Barcode: xBarcode,
    };
    const CartBarcodeDetail = await fExecuteAPI(
      "LOADING_ITEMSEARCH_GETROW",
      CartBarcodeDetailObj
    );
    if (CartBarcodeDetail?.Type?.toUpperCase() === "SUCCESS") {
      if (CartBarcodeDetail.ResultSet.length > 0) {
        let vBalanceQty =
          fcovertToNumber(CartBarcodeDetail.ResultSet[0].LoadQty) -
          fcovertToNumber(CartBarcodeDetail.ResultSet[0].LoadingQty);
        setDetail((obj) => ({
          ...obj,
          ItemCode: CartBarcodeDetail.ResultSet[0].ItemCode,
          ItemName: CartBarcodeDetail.ResultSet[0].ItemName,
          LoadQty: CartBarcodeDetail.ResultSet[0].LoadQty,
          LoadingQty: CartBarcodeDetail.ResultSet[0].LoadingQty,
          SuppRefNo1: CartBarcodeDetail.ResultSet[0]?.SuppRefNo1,
          BalanceQty: vBalanceQty,
        }));
        if (CartBarcodeDetail.ResultSet[0].ItmCd !== "" && xeditRow == false) {
          let itemCdInfo = await GetUnitDetail(
            CartBarcodeDetail.ResultSet[0].ItemCode
          );
          if (itemCdInfo.length > 0) {
            var vUnit = itemCdInfo.find((obj) => {
              return obj.Unit == CartBarcodeDetail.ResultSet[0].Unit;
            });
            if (!!vUnit) {
              fBaseQty(sDetail.Qty, vUnit.PackQty);
              setDetail((obj) => ({
                ...obj,
                Unit: vUnit.Unit,
                PackQty: vUnit.PackQty,
              }));
            } else {
              setDetail((obj) => ({
                ...obj,
                Unit: itemCdInfo[0].Unit,
                PackQty: itemCdInfo[0].PackQty,
              }));
              fBaseQty(sDetail.Qty, itemCdInfo[0].PackQty);
              fAlertToast("FAILED", "UnitID and Card UnitID Not Matched");
            }
          }
        }
        document.getElementById("Qty")?.focus();
      } else {
        setDetail((obj) => ({
          ...obj,
          ItemCode: "",
          SrNo: 0,
          ItemName: "",
          // BarCode: "",
          Unit: "",
          PackQty: "",
          LoadQty: "",
          LoadingQty: "",
          BalanceQty: "",
          SuppRefNo1: 0,
        }));
        setUnitDataArr([]);
        fBaseQty(sDetail.Qty, 0);
        fAlertToast("WARNING", "Wrong card Id");
      }
    } else {
      setUnitDataArr([]);
      fAlertToast(
        "FAILED",
        CartBarcodeDetail.Message ||
          CartBarcodeDetail.response.data.message ||
          "Error"
      );
    }
  };

  const GetUnitDetail = async (xItemCode) => {
    const UnitInfo = await fExecuteAPI(
      "ITEM_UNIT_INSTANTPICKING_GETROW",
      xItemCode
    );
    if (UnitInfo.Type == "SUCCESS") {
      if (UnitInfo.ResultSet.length > 0) {
        setUnitDataArr(UnitInfo.ResultSet);
        return UnitInfo.ResultSet;
      }
    } else if (UnitInfo.Type == "FAILED") {
      setUnitDataArr([]);
      fAlertToast("FAILED", UnitInfo.Message);
      return [];
    }
  };

  //API LOADING_ITEMLIST_GETROW
  const GetItems = async () => {
    let vItemsObj = {
      G_VocTyp: vRdxDetail.VocTyp,
      G_VocNo: vRdxDetail.VocNo,
    };
    const vItems = await fExecuteAPI("LOADING_ITEMLIST_GETROW", vItemsObj);
    if (vItems.Type == "SUCCESS") {
      let GridID = vItems.ResultSet?.map((obj, i) => ({ ...obj, id: i + 1 }));
      setGridRow(GridID);
    } else {
      fAlertToast(
        "FAILED",
        fErrorMessage(vItems) || "Error in loading summarylist"
      );
    }
  };

  //API LOADING_ITEMDELETE_GETROW
  const GetDeleteItems = async () => {
    let vDeleteItemsObj = {
      G_VocTyp: vRdxDetail.VocTyp,
      G_VocNo: vRdxDetail.VocNo,
      G_SrNo: sDetail.SrNo,
    };
    const vDeleteItems = await fExecuteAPI(
      "LOADING_ITEMDELETE_GETROW",
      vDeleteItemsObj
    );
    if (vDeleteItems.Type == "SUCCESS") {
      return vDeleteItems;
    } else {
      fAlertToast("FAILED", fErrorMessage(vDeleteItems) || "Error in deleting");
      return vDeleteItems;
    }
  };
  //API LOADING_VARIANCE_LDList_GETROW
  const GetVariance = async () => {
    let vVarianceObj = {
      VocTyp: vRdxDetail.VocTyp,
      VocNo: vRdxDetail.VocNo,
    };
    const vVariance = await fExecuteAPI(
      "LOADING_VARIANCE_LDList_GETROW",
      vVarianceObj
    );
    if (vVariance.Type == "SUCCESS") {
      let GridID = vVariance.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridVarienceRow(GridID);
    } else {
      fAlertToast("FAILED", fErrorMessage(vVariance));
    }
  };
  //API LOADING_ITEMPOST_GETROW
  const GetPost = async () => {
    let vPostDispatchObj = {
      G_VocTyp: vRdxDetail.VocTyp,
      G_VocNo: vRdxDetail.VocNo,
    };
    const vPostDispatch = await fExecuteAPI(
      "LOADING_ITEMPOST_GETROW",
      vPostDispatchObj
    );
    if (vPostDispatch.Type == "SUCCESS") {
      // setsInstantPickingDetail((obj) => ({ ...obj, Status: "Completed" }));
      dispatch(LoadingHead_Status_Set({ Status: "Completed" }));
      fAlertToast("SUCCESS", "Successfully posted");
      fNew();
    } else {
      fAlertToast("FAILED", fErrorMessage(vPostDispatch));
    }
  };

  //API LOADING_ITEMSAVE_GETROW
  const GetSaveItems = async () => {
    let vSaveItemsObj = {
      G_VocTyp: vRdxDetail.VocTyp,
      G_VocNo: vRdxDetail.VocNo,
      G_SrNo: sDetail.SrNo,
      G_BinCd: vRdxDetail.LoadingBayCode,
      G_CardID: sDetail.BarCode,
      G_ItmCd: sDetail.ItemCode,
      G_Qty: sDetail.Qty,
      G_Drop_ID: sDetail.DropID,
      G_Unit: sDetail.Unit,
      G_BaseQty: sDetail.BaseQty,
      G_NDX_ROWID: sDetail.IndexRowID,
      G_RefDocTyp: sDetail.RefDocTyp,
      G_RefDocNo: sDetail.RefDocNo,
      UserID: vRdxuserInfo.UserID,
      G_Loc: vRdxDetail.Loc,
    };

    const vSaveItems = await fExecuteAPI(
      "LOADING_ITEMSAVE_GETROW",
      vSaveItemsObj
    );
    if (vSaveItems.Type == "SUCCESS") {
      return vSaveItems;
    } else {
      fAlertToast(
        "FAILED",
        vSaveItems.Message ||
          vSaveItems.response.data.message ||
          "Error in loading Item"
      );
      return vSaveItems;
    }
  };

  const fGridRowData = async (e) => {
    setDetail((obj) => ({
      ...obj,
      SrNo: e.row.G_SrNo,
      ItemCode: e.row.G_ItmCd,
      ItemName: e.row.ItmName,
      BarCode: e.row.G_CardID,
      CardId: e.row.G_CardID,
      Qty: e.row.G_Qty,
      BaseQty: e.row.G_BaseQty,
      IndexRowID: e.row.G_NDX_ROWID,
      RefDocTyp: e.row.G_RefDocTyp,
      RefDocNo: e.row.G_RefDocNo,
      SuppRefNo1: e.row.SuppRefNo1,
      DropID: e.row.G_Drop_ID,
    }));
    //to load loadqty,loadingty ,balanceQty
    GetCartBarcodeDetail(e.row.G_SrNo, e.row.G_CardID, true);
    let itemCdInfo = await GetUnitDetail(e.row.G_ItmCd);
    if (itemCdInfo.length > 0) {
      let currObj = itemCdInfo.find((obj) => {
        return obj.Unit == e.row.G_Unit;
      });
      fBaseQty(e.row.G_Qty, currObj.PackQty);
      setDetail((obj) => ({
        ...obj,
        Unit: currObj.Unit,
        PackQty: currObj.PackQty,
      }));
    }
    fCloseDetailViewModel();
  };

  useEffect(() => {
    GetItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sVarianceColumns, setVarianceColumns] = useState([]);
  const [scolumns, setcolumns] = useState([]);

  useEffect(() => {
    GetGitterColumns(setcolumns, "LOADING_DETAIL", columns);
    GetGitterColumns(setVarianceColumns, "LOADING_VARIANCE", VarianceColumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    LoadingDetailFocusOnLoad.current?.focus();
  }, []);
  const buttonStyle1 = {
    background: "red",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle2 = {
    background: "green",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle3 = {
    background: "indigo",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  const buttonStyle4 = {
    background: "gray",
    borderRadius: "20px",
    padding: "1px 17px",
    color: "white",
    textTransform: "none",
    minWidth: "-webkit-fill-available",
  };
  return (
    <div className="container-fluid py-2 ">
      <div className="Breadcrumbs m-0">
        <Loading_Breadcrumbs />
      </div>
      <div className="Instantg-picking-detail-v1">
        <Box sx={{ flexGrow: 1 ,display:'none'}} className="xs-instant-picking-detail-label" >
          <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Doc.Type</label>
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Doc.Type"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.VocTyp}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocTyp"}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Doc.Name"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.VocTypName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocTypName"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 2, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Doc.No</label>
                </Grid>
                <Grid item xs={10}>
                  <CmpTextField
                    xLabelText={"Doc.No"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.VocNo}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocNo"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Party</label>
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Party"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.Party}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Party"}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"PartyName"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.PartyName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"PartyName"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Status</label>
                </Grid>
                <Grid item xs={3}>
                  <CmpTextField
                    xLabelText={"Status"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.Status}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Status"}
                  />
                </Grid>
                <Grid item xs={2}>
                  <CmpTextField
                    xLabelText={"TruckName"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.TruckName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"TruckName"}
                  />
                </Grid>
                <Grid item xs={3}>
                  <CmpTextField
                    xLabelText={"LoadingBay"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.LoadingBay}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"LoadingBay"}
                  />
                </Grid>
                <Grid item xs={2}>
                  <CmpTextField
                    xLabelText={"Drive"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.Drive}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Drive"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <br></br>
        {/* <Grid
              container
              spacing={0}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className="mb-1"
            >
              <Grid item xs={'auto'} sm={'auto'} md={'auto'}>
                <CmpTypographyField
                  xcomponent={"span"}
                  xText={"RefNo=" + sDetail.SuppRefNo1}
                />
              </Grid>
              
            </Grid> */}
        <Grid
          container
          spacing={0.5}
          columns={{ xs: 12, sm: 12, md: 12 }}
          className="mb-3 buttonstyle"
        >
          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Pick Qty=" + sDetailQty.PickQty}
                /> */}
            <Button size="small" style={buttonStyle1}>
              Doc.No &nbsp; {vRdxDetail?.VocNo}
            </Button>
          </Grid>

          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Pick Qty=" + sDetailQty.PickQty}
                /> */}
            <Button size="small" style={buttonStyle3}>
              Load Qty &nbsp; &nbsp; {sDetail?.LoadQty}
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Picked Qty=" + sDetailQty.PickedQty}
                /> */}
            <Button size="small" style={buttonStyle4}>
              Loadin Qty &nbsp; &nbsp; {sDetail?.LoadingQty}
            </Button>
          </Grid>
          <Grid item xs={6} sm={6} md={3} textAlign={"center"}>
            {/* <CmpTypographyField
                  xcomponent={"span"}
                  xText={"Balance Qty=" + sDetailQty.BalQty}
                /> */}
            <Button size="small" style={buttonStyle2}>
              Balance Qty &nbsp; &nbsp;{sDetail?.BalanceQty}
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 8, sm: 12, md: 12 }}>
                <Grid item xs={4} sm={3} md={3}>
                  {/* <CmpTextField
                    xLabelText={"SrNo"}
                    xVariant={"outlined"}
                    xValue={sDetail.SrNo}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"SrNo"}
                    xError={sErrorMsg.SrNo === "" ? false : true}
                    xErrorMessage={sErrorMsg.SrNo}
                  /> */}
                  <CmpTextField
                    xLabelText={"RefNo"}
                    xVariant={"outlined"}
                    xValue={sDetail.SuppRefNo1}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"RefNo"}
                    xError={false}
                    xErrorMessage={""}
                  />
                </Grid>
                <Grid item xs={4} sm={3} md={3}>
                  <CmpTextFieldEnter
                    xref={LoadingDetailFocusOnLoad}
                    xLabelText={"BarCode"}
                    xVariant={"outlined"}
                    xValue={sDetail.BarCode}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"BarCode"}
                    xOnKeyUp={(e) => {
                      fOnKeyUp(e);
                    }}
                    xError={sErrorMsg.BarCode === "" ? false : true}
                    xErrorMessage={sErrorMsg.BarCode}
                    xOnEnter={(e) => {
                      fOnKeyUp(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                
              
                <Grid
                  item
                  xs={4}
                  sm={4}
                  md={3}
                  style={{ display: WMS_PICKING_DROP_ID_Flag() ? "" : "none " }}
                >
                  <CmpTextField
                    xLabelText={"Drop Id"}
                    xVariant={"outlined"}
                    xValue={sDetail.DropID}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"DropID"}
                    xError={sErrorMsg.DropID === "" ? false : true}
                    xErrorMessage={sErrorMsg.DropID}
                  />
                </Grid>
                <Grid item xs={WMS_PICKING_DROP_ID_Flag() ? 2:4} sm={2} md={3}>
                  <CmpTextField
                    xLabelText={"ItemCode"}
                    xVariant={"outlined"}
                    xValue={sDetail.ItemCode}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"ItemCode"}
                    xError={sErrorMsg.ItemCode === "" ? false : true}
                    xErrorMessage={sErrorMsg.ItemCode}
                  />
                </Grid>
                <Grid item xs={4} sm={4} md={3}>
                  <CmpTextField
                    xLabelText={"ItemName"}
                    xVariant={"outlined"}
                    xValue={sDetail.ItemName}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"ItemName"}
                    xError={sErrorMsg.ItemName === "" ? false : true}
                    xErrorMessage={sErrorMsg.ItemName}
                  />
                </Grid>
                <Grid item xs={2} sm={3} md={2}>
                  <CmpTextField
                    xLabelText={"Qty"}
                    xVariant={"outlined"}
                    xValue={sDetail.Qty}
                    xOnChange={(event) => fOnChangeInputQty(event)}
                    xReadOnly={false}
                    xType={"number"}
                    xName={"Qty"}
                    xOnKeyUp={(e) => {
                      fQtyKey(e);
                    }}
                    xError={sErrorMsg.Qty === "" ? false : true}
                    xErrorMessage={sErrorMsg.Qty}
                  />
                </Grid>
                <Grid item xs={3} sm={3} md={2}>
                  <CmpSelectBox
                    xLabelText="Unit"
                    xValue={sDetail.Unit}
                    xOnChange={(event) => fUnitSelect(event)}
                    xName={"Unit"}
                    xData={sUnitData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={sErrorMsg.Unit === "" ? false : true}
                    xErrorMessage={sErrorMsg.Unit}
                    xDisable={false}
                  />
                </Grid>
                <Grid item xs={3} sm={3} md={2}>
                  <CmpTextField
                    xLabelText={"BaseQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.BaseQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BaseQty"}
                    xError={sErrorMsg.BaseQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.BaseQty}
                  />
                </Grid>
                {/* <Grid item xs={2} sm={3} md={2}>
                  <CmpTextField
                    xLabelText={"LoadQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.LoadQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"LoadQty"}
                    xError={sErrorMsg.LoadQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.LoadQty}
                  />
                </Grid>
                <Grid item xs={3} sm={3} md={2}>
                  <CmpTextField
                    xLabelText={"LoadingQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.LoadingQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"LoadingQty"}
                    xError={sErrorMsg.LoadingQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.LoadingQty}
                  />
                </Grid>
                <Grid item xs={3} sm={3} md={2}>
                  <CmpTextField
                    xLabelText={"BalanceQty"}
                    xVariant={"outlined"}
                    xValue={sDetail.BalanceQty}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"BalanceQty"}
                    xError={sErrorMsg.BalanceQty === "" ? false : true}
                    xErrorMessage={sErrorMsg.BalanceQty}
                  />
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 6, sm: 12, md: 10 }}
            className="text-center"
          >
            <Grid item xs={2}>
              <CmpButton
                xbtnName="New"
                xOnClick={fNew}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Save"
                xOnClick={fSave}
                xVariant="contained"
                xSize="small"
                xDisabled={vRdxDetail.Status === "Completed" ||sLoading}
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Delete"
                xOnClick={fDelete}
                xVariant="contained"
                xSize="small"
                xDisabled={vRdxDetail.Status === "Completed"}
              />
            </Grid>
            <Grid item xs={2} className="btn-instant-picking-Detail">
              <CmpButton
                xbtnName="Detail"
                xOnClick={fDetail}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Post"
                xOnClick={fPost}
                xVariant="contained"
                xSize="small"
                xDisabled={vRdxDetail.Status === "Completed"}
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Variance"
                xOnClick={fVariance}
                xVariant="contained"
                xSize="small"
              />
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <div className="container-fluid mt-3">
          <div className="xs-instant-picking-detail-grid">
            {/* <Box sx={{ height: vMediaQuery ? "70vh" : "40vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sGridRow}
                columns={scolumns}
                // pageSize={5}
                // rowsPerPageOptions={[5]}
                hideFooter={sGridRow.length < 100}
                onRowClick={fGridRowData}
                components={{
                  Toolbar: GridToolbar,
                }}
              />
            </Box> */}
            <LoadingDetailTblCard data={sGridRow} onClick={fGridRowData}/>
          </div>
        </div>
      </div>
      <Modal
        open={sOpenDetailViewModel}
        onClose={fCloseDetailViewModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance detail">
          <div>
           
            <GCTitleSticky title={'Detail'} onClose={fCloseDetailViewModel} />
       

            {/* <Box
                style={{ height: vMediaQuery ? "70vh" : "40vh", width: "100%" }}
                className="bintransfer-out-grid"
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridRow}
                  columns={scolumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  hideFooter={sGridRow.length < 100}
                  onRowClick={fGridRowData}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </Box> */}
             <LoadingDetailTblCard data={sGridRow} onClick={fGridRowData}/>
          </div>
        </Box>
      </Modal>

      <Modal
        open={sOpenPostVarianceModel}
        onClose={fCloseVarianceModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <div>
            
            <GCTitleSticky title={'Variance'} onClose={fCloseVarianceModel} />
       
         
              <Box
                style={{ height: vMediaQuery ? "70vh" : "65vh", width: "100%" }}
                className="bintransfer-out-grid"
              >
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    Number(params.row.Variance) === 0
                      ? "mui-green-row"
                      : params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridVarienceRow}
                  columns={sVarianceColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  hideFooter={sGridRow.length < 100}
                  components={{
                    Toolbar:vMediaQuery?"": GridToolbar,
                  }}
                />
                {/* <LoadingVarianceTblCard data={sGridVarienceRow} /> */}
              </Box>
           

            {/* {vMediaQuery && sGridVarienceRow?.length > 0 && (
              <Box>
                <Grid
                  container
                  spacing={{ xs: 0, md: 3 }}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  {sGridVarienceRow?.map((obj, index) => (
                    <Grid item xs={12} sm={12} md={6} key={index}>
                      
                      <LoadingVarianceTblCard data={sGridVarienceRow} />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )} */}
          </div>
        </Box>
      </Modal>
    </div>
  );
}
